// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'arrow-right-column';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M14.866 11.134 16.999 9m0 0-2.133-2.133M16.999 9H6.333M1 17h4.266a1.067 1.067 0 0 0 1.067-1.067V2.067A1.067 1.067 0 0 0 5.266 1H1'
  />
);

export const viewBox = '0 0 18 18';
